import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    subheaderOne: {
        id: '_.loan_builder.subheader_one',
        defaultMessage: 'Get your own account manager'
    },
    subheaderTwo: {
        id: '_.loan_builder.subheader_two',
        defaultMessage: 'Top up your loan in a few clicks'
    },
    subheaderThree: {
        id: '_.loan_builder.subheader_three',

        defaultMessage: 'No early repayment fees'
    }
});
